import BaseModel from '../core/BaseModel'
//import CategoriesModel from './CategoriesModel'
export default class ProductMaintenanceModel extends BaseModel {
    constructor() {
        super({ 
                name: "product_maintenance",
                tableName: 'core_product_maintenance'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            fied_detail: {
                refs: 'parts_number time_between_maintenance list_service_pack_id ',
                display: false
            },
        },)
    }

}